import i18next from 'i18next';

export const DEFAULT_EVENT_DELAY = 100;

export const DEFAULT_MAX_RESULTS = 6;

const ERORR_CODES = {
  PERMISSION_DENIED: 1,
  POSITION_UNAVAILABLE: 2,
  TIMEOUT: 3
};

export const ERROR_TEXTS = {
  [ERORR_CODES.PERMISSION_DENIED]: i18next.t('StoreSearchBar:PERMISSION_DENIED'),
  [ERORR_CODES.POSITION_UNAVAILABLE]: i18next.t('StoreSearchBar:POSITION_UNAVAILABLE'),
  [ERORR_CODES.TIMEOUT]: i18next.t('StoreSearchBar:TIMEOUT')
};

export const MIN_LENGTH_TO_SEARCH = 4;

export const DELAY_SEARCH_TIME = 400;
